import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { getApprovalHistoryReport, getApprovalHistoryReportExcelData, setApprovalHistoryReportExcelData, setApprovalHistoryReportFilters } from 'Store/OrderManagement/ApprovalHistoryReport/ApprovalHistoryReportAction';
import { getMarketDropDown } from 'Store/Organization/Market/MarketAction';
import { getRegion, getRegionDropDown } from 'Store/Organization/Region/RegionAction';
import ApprovalHistoryReport from '../ApprovalHistoryandComplianceReport'
import useLocationDropDowns from '../ApprovalManagement.hook';
import { fetchGridData, handleChange, handleChangeSearchedCostCenter, onDateChange, searchCostCenter } from '../ApprovalFunctions';
import { base64ToArrayBuffer, saveByteArray } from 'utils';
import moment from 'moment';
import { getCostCenterByMarket } from 'Store/Organization/CostCenterByMarket/CostCenterByMarketAction';


const defaultDateRange = [new Date(moment().subtract(3, "months").toDate()), new Date(moment().toDate())]

const ApprovalHistoryContainer = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [costCentersBySearchList, setCostCentersBySearchList] = useState([])
  const [approvalHistoryGridData, setApprovalHistoryGridData] = useState<any[]>([])

  //selectors
  const {
    regionDropDown = [],
    marketDropDown = [],
    costCenterByMarketDropDownList = [],
    costCenterBySearchDropDownList = [],
    getUserDetails,
    approvalHistoryReport = [],
    approvalHistoryReportFilters,
    approvalHistoryReportExcelData
  }: any = useSelector((state: any) => ({
    regionDropDown: state?.RegionDropDownReducer?.regionDropDown,
    marketDropDown: state?.MarketDropDownReducer?.marketDropDown,
    costCenterByMarketDropDownList: state.CostCenterByMarketReducers.costCenterByMarket,
    costCenterBySearchDropDownList: state.CostCentersReducer.costCenterBySearchDropDownList,
    getUserDetails: state.UserProfile.getUserDetails,
    approvalHistoryReport: state?.ApprovalHistoryReportReducer?.approvalHistoryReport,
    approvalHistoryReportFilters: state?.ApprovalHistoryReportReducer?.approvalHistoryReportFilters,
    approvalHistoryReportExcelData: state?.ApprovalHistoryReportReducer?.approvalHistoryReportExcelData
  }))

  const [
    regionDropDownList,
    marketDropDownList,
    costCentersByMarketList
  ] = useLocationDropDowns({
    regionDropDown,
    marketDropDown,
    costCenterByMarketDropDownList,
    getRegion,
    getMarketDropDown,
    getCostCenterByMarket,
    approvalHistoryReportFilters,
    isApprovalHistory : true
  })

  const [showHistoryGrid, setShowHistoryGrid] = useState<any>(approvalHistoryReport?.data?.length > 0);
  const [pagesCount, setPagesCount] = useState<number>(approvalHistoryReportFilters?.pagesCount ?? 0)
  const [pagingData, setPagingData] = useState<any>(approvalHistoryReportFilters?.paginationData)
  const [sortingData, setSortingData] = useState<any>(approvalHistoryReportFilters?.sortData)

  useEffect(() => {
    dispatch(getRegionDropDown());
  }, [])

  useEffect(() => {
    if (costCenterBySearchDropDownList?.length) {
      const branchTypeDropdownListTemp = costCenterBySearchDropDownList?.map((item: any) => ({ ...item, label: item?.text }));
      setCostCentersBySearchList(branchTypeDropdownListTemp);
    }
  }, [costCenterBySearchDropDownList])

  useEffect(() => {
    dispatch(setApprovalHistoryReportFilters({ ...approvalHistoryReportFilters, paginationData: pagingData, sortData: sortingData}))
  }, [pagingData, sortingData])

  useEffect(() => {
    if (approvalHistoryReport?.data) {
      const tempData = approvalHistoryReport?.data?.map((item: any) => ({
        ...item,
        orderDate: moment(item?.orderDate).format("MM/DD/YYYY")
      }))
      setApprovalHistoryGridData(tempData)
    } else {
      setApprovalHistoryGridData([])
    }
  }, [approvalHistoryReport?.data])

  useEffect(() => {
    if (approvalHistoryReport?.totalRecords && approvalHistoryReportFilters?.paginationData?.pageSize) {
      let pageSize = approvalHistoryReportFilters?.paginationData?.pageSize ?? 0;
      let tempPageCount = approvalHistoryReport?.totalRecords > pageSize ? Math.ceil(approvalHistoryReport?.totalRecords / pageSize - 1) : 0
      setPagesCount(tempPageCount)
      dispatch(setApprovalHistoryReportFilters({ ...approvalHistoryReportFilters, pagesCount: tempPageCount }))
    }
  }, [approvalHistoryReport?.totalRecords, approvalHistoryReportFilters?.paginationData?.pageSize])


  const getLocationFilter = () => {
    if (approvalHistoryReportFilters?.costCenter?.value) {
      return { type: "costcenter", id: approvalHistoryReportFilters?.costCenter?.value }
    } else if (approvalHistoryReportFilters?.market?.value) {
      return { type: "market", id: approvalHistoryReportFilters?.market?.value }
    } else if (approvalHistoryReportFilters?.region?.value) {
      return { type: "region", id: approvalHistoryReportFilters?.region?.value }
    }
  }

  useEffect(() => {
  const costCenterValue = approvalHistoryReportFilters?.searchedCostCenter?.value ? {type: "costcenter" , id: approvalHistoryReportFilters?.searchedCostCenter?.value} : getLocationFilter()
  if(costCenterValue){
    fetchGridData(costCenterValue, approvalHistoryReportFilters?.dateRange ?? defaultDateRange, approvalHistoryReportFilters?.paginationData, approvalHistoryReportFilters?.sortData, getUserDetails?.emailId, getApprovalHistoryReport, dispatch, true)
  }
  }, [approvalHistoryReportFilters?.paginationData, approvalHistoryReportFilters?.sortData])

  useEffect(()=>{
    if(approvalHistoryReportExcelData){
      const byteArray = base64ToArrayBuffer(approvalHistoryReportExcelData)
      saveByteArray('Approval_History_List', byteArray, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
      dispatch(setApprovalHistoryReportExcelData(null))
  }
  }, [approvalHistoryReportExcelData])


  const handleDropDownsChange = (value: any, name: string) => {
    handleChange(value, name, setApprovalHistoryReportFilters, approvalHistoryReportFilters, setShowHistoryGrid, dispatch)
  }

  const searchCostCenterFunction = (value: any, action: any) => {
    searchCostCenter(value, action, dispatch)
  }

  const onChangeSearchCostCenter = (value: any) => {
    handleChangeSearchedCostCenter(value, setApprovalHistoryReportFilters, {...approvalHistoryReportFilters, dateRange: approvalHistoryReportFilters?.dateRange ?? defaultDateRange }, getUserDetails?.emailId, getApprovalHistoryReport, setShowHistoryGrid, dispatch, true)
  }

  const onDateRangeChange = (date: any) => {
    const costCenterValue = approvalHistoryReportFilters?.searchedCostCenter?.value ? {type: "costcenter" , id: approvalHistoryReportFilters?.searchedCostCenter?.value} : getLocationFilter()
    onDateChange(date, setApprovalHistoryReportFilters, approvalHistoryReportFilters, getUserDetails?.emailId, getApprovalHistoryReport, dispatch, true, costCenterValue)
  }

  const fetchAction = useCallback((fetchData: any) => {
    if (fetchData.action && fetchData.action === "paging") {
      let paginationData = fetchData.data
      setPagingData(paginationData)
    }
    if (fetchData.action && fetchData.action === "sorting") {
      const data = fetchData.data[0];
      setSortingData(data)
    }
  }, [])

  const onOrderIdClicked = (row: any) => {
    navigate(`approvalhistory/${row?.rowData?.orderRequestId}`)
  }

  const columns = [
    {
      key: "orderRequestId",
      title: "Order #",
      Cell: (row: any) => {
        return (
          <a
            href="/"
            onClick={(e: any) => {
              e?.preventDefault()
              onOrderIdClicked(row);
            }}
            className="order-link-id"
          >
            {row.rowData.orderRequestId}
          </a>
        );
      },
      width: 240
    },
    {
      key: "costCenterCode",
      title: "Cost Center #",
      width: 230
    },
    {
      key: "costCenterName",
      title: "Cost Center Name",
      width: 230
    },
    {
      key: "requestType",
      title: "Request Type",
      width: 230,
      Cell: (typeRow: any) => {
        const requesttype = typeRow.rowData.orderRequestType?.toString();
        return (
          <p>{requesttype?.replaceAll(",", " | ")}</p>);
      },
    },
    {
      key: "status",
      title: "Request Status",
      width: 230
    },
    {
      key: "orderDate",
      title: "Order Date",
      width: 230
    }
  ];

  const search = () => {
    const costCenterValue = getLocationFilter()
    if(costCenterValue){
      fetchGridData(costCenterValue, approvalHistoryReportFilters?.dateRange ?? defaultDateRange, approvalHistoryReportFilters?.paginationData, approvalHistoryReportFilters?.sortData, getUserDetails?.emailId, getApprovalHistoryReport, dispatch, true)
      dispatch(setApprovalHistoryReportFilters({ ...approvalHistoryReportFilters, searchedCostCenter: "" }))
      setShowHistoryGrid(true)
    }
  }

  const onExportExcel = () => {
    const costCenterValue = approvalHistoryReportFilters?.searchedCostCenter?.value ? {type: "costcenter" , id: approvalHistoryReportFilters?.searchedCostCenter?.value} : getLocationFilter()
    fetchGridData(costCenterValue, approvalHistoryReportFilters?.dateRange ?? defaultDateRange, approvalHistoryReportFilters?.paginationData, approvalHistoryReportFilters?.sortData, getUserDetails?.emailId, getApprovalHistoryReportExcelData, dispatch, true)
  }

  const onClearClick = () => {
    setShowHistoryGrid(false)
    dispatch(setApprovalHistoryReportFilters({ ...approvalHistoryReportFilters, region: "", market: "", costCenter: "", searchedCostCenter: "", dateRange: defaultDateRange }))
  }

  return (
    <ApprovalHistoryReport
      regionDropDownList={regionDropDownList}
      selectedRegion={approvalHistoryReportFilters?.region}
      marketDropDownList={marketDropDownList}
      selectedMarket={approvalHistoryReportFilters?.market}
      handleChange={handleDropDownsChange}
      costCentersByMarketList={costCentersByMarketList}
      costCentersBySearchList={costCentersBySearchList}
      selectedCostCenter={approvalHistoryReportFilters?.costCenter}
      gridData={approvalHistoryGridData ?? []}
      columns={columns}
      showGrid={showHistoryGrid}
      onExportExcel={onExportExcel}
      searchCostCenter={searchCostCenterFunction}
      handleChangeSearchedCostCenter={onChangeSearchCostCenter}
      selectedSearchedCostCenter={approvalHistoryReportFilters?.searchedCostCenter}
      onDateChange={onDateRangeChange}
      dateRange={approvalHistoryReportFilters?.dateRange ?? defaultDateRange}
      serverTotal={approvalHistoryReport?.totalRecords}
      pagesCount={pagesCount}
      fetchAction={fetchAction}
      paginationData={approvalHistoryReportFilters?.paginationData}
      search={search}
      getLocationFilter={getLocationFilter}
      isApprovalHistory={true}
      onClearClick = {onClearClick}
    />
  )
}

export default ApprovalHistoryContainer